export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='3'
      y='3'
      width='10'
      height='14'
      rx='2'
      stroke='#5A607F'
      strokeWidth='1.5'
    />
    <path
      d='M6 6.5H10'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M6 9H10'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M6 11.5H9'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <g transform='translate(12, 10)'>
      <circle cx='4' cy='4' r='2.5' stroke='#5A607F' strokeWidth='1.5' />
      <path
        d='M4 1V0'
        stroke='#5A607F'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path
        d='M4 8V7'
        stroke='#5A607F'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path
        d='M1 4H0'
        stroke='#5A607F'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path
        d='M8 4H7'
        stroke='#5A607F'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
    </g>
  </svg>
);
